import { useContext } from "react";

import { actions } from "../context/AppProvider";
import appContext from "../context/appContext";
import { useViewport } from "../../../components/ReactContext_Viewport";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";

const DownloadButton = () => {
    const { screenSize } = useViewport();
    const { state, dispatch } = useContext(appContext);
    if (state.selectedGeos.length === 0) return null;
    return (
        <>
            <button
                className="downloadBtn"
                style={{
                    display: screenSize === "mobile" ? "none" : "block",
                }}
                onClick={() => {
                    dispatch({ type: actions.SET_IS_DOWNLOAD_MODAL_OPEN, to: true });
                }}
            >
                <FontAwesomeIcon icon={faFileDownload} style={{ marginRigh: 10 }} /> Download Profile
            </button>
        </>
    );
};
export default DownloadButton;
